import { render, staticRenderFns } from "./InsightsDisplay.vue?vue&type=template&id=f83590ec&scoped=true"
import script from "./InsightsDisplay.vue?vue&type=script&lang=js"
export * from "./InsightsDisplay.vue?vue&type=script&lang=js"
import style0 from "./InsightsDisplay.vue?vue&type=style&index=0&id=f83590ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83590ec",
  null
  
)

export default component.exports